<template>
    <CModal @mtdclosemodal="mtdclosemodal" :show="boo_modal" :close-on-backdrop="false" :centered="true" :title="title" :size="'lg'" :btn_cancel="true" :btn_ok="true" :booTitile="true">
        <div v-if="num ==1" class="row mx-0  px-2">
            <div class="row mx-0 px-0" v-if="data.length > 0">
                <div class="col-xl-4 col-md-6 col-sm-12 mb-1  px-1 " v-for="(item,index) in data" :key="index">
                    <div class="text-center  text-white rounded rounded-2 btn-asistencial text-xxs h-100 border border-main border-3">
                        <button @click="addRoom(item)" type="button" class="btn w-100 text-xs h-100 ">
                            {{ item.name}}
                        </button>
                    </div>
                </div>
            </div>
            <div class="text-center fw-bold" v-else>
                <span>No hay registros</span>
            </div>
        </div>
        <div v-else class="row mx-0  px-2">
            <div class="row mx-0 px-0" v-if="data2.length > 0">
                <div class="col-xl-3 mb-1  px-1 " v-for="(item,index) in data2" :key="index">
                    <div class="text-center  text-white rounded rounded-2 btn-asistencial text-xxs h-100 border border-main border-3">
                        <button @click="addbedsub (item)" type="button" class="btn w-100 text-xs h-100 ">
                            {{ item.name}}
                        </button>
                    </div>
                </div>
            </div>
            <div class="text-center fw-bold" v-else>
                <span>No hay registros</span>
            </div>
        </div>
        <template #footer>
            <!-- <button @click="mtdclosemodal" class="btn btn-danger btn-sm">
                <i class="fa fa-times" />&nbsp;Cerrar
            </button>
            <button class="btn btn-success btn-sm">
                Guardar
            </button>
            &nbsp; -->
        </template>
        <SweetAlert :swal="swal" ref="SweetAlert" />
    </CModal>
    </template>
    
    <script>
    import CModal from "@/components/shared/modals/CModal.vue";
    import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
    import {
        mapActions
    } from "vuex";
    
    export default {
        name: "c-medico-modal-operation",
    
        data() {
            return {
                swal: null,
                data: [],
                data2:[],
                num: null,
                room:{}
            }
        },
        components: {
            CModal,
            SweetAlert
        },
        
        props: {
            title: String,
            boo_modal: Boolean
    
        },
        watch: {
            boo_modal: {
                handler(newVal) {
                    if(newVal == true){
                        this.mtdGetData();
                    }
                },
                immediate: true
            }
        },
        methods: {
            ...mapActions(["get", "post"]),
            mtdclosemodal() {
                this.$emit('mtdclosemodalBed')
            },
            mtdGetData: function () {
                this.num = 1;
                this.post({
                    url: this.$store.getters.get__url + "/OperationsRoom/filter",
                    token: this.$store.getters.get__token,
                    params: {
                        campus_id: this.$store.getters.get__campus
                    },
                })
                    .then((response) => {
                        this.data = response.data;
                    })
                    .catch((errors) => {
                        this.$refs.SweetAlert.showError(errors);
                    });
            },
            addbed: function (payload) {
                this.cama = payload
                this.num = 2
            },
            addbedsub : function(payload){
                this.$emit('mtdaddbed', this.cama, this.bed.type,payload)
                this.cama = {}
                this.num = null
            },
            addRoom: function (payload){
                this.room = payload;
                this.$emit('saveOperationRoom',payload)

            }
    
        },
    }
    </script>
    